/* eslint-disable */

import { IconButton } from '@material-ui/core';
import SummarizeIcon from '@mui/icons-material/Summarize';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import {
  Cancel as CancelIcon,
  CancelOutlined as CancelOutlinedIcon,
  CheckCircle as CheckCircleIcon,
  DoneAll as DoneAllIcon,
  MoreHoriz as MoreHorizIcon,
  Payment as PaymentIcon,
  Receipt as ReceiptIcon,
} from '@material-ui/icons';
import _, { isFunction } from 'lodash';
import { bindMenu, bindTrigger } from 'material-ui-popup-state';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import QCXApplyJurosDialogForm from '../../../../components/contas-pagar-receber/QCXApplyJurosDialogForm';
import QCXPartialValuesDialogForm from '../../../../components/contas-pagar-receber/QCXPartialValueDialogForm';
import QCXRelatoriosContasDialogForm from '../../../../components/contas-pagar-receber/QCXRelatoriosContasDialogForm';
import QCXPopupState from '../../../../components/popup-state/QCXPopupState';
import ContasReceberContext from '../../../../contexts/financial/contas-receber/ContasReceberContext';
import { contasReceberAPI } from '../../../../features/contas-receber/contasReceberAPI';
import {
  selectContasReceber,
  selectContasReceberView,
  selectMode,
  selectRefresh,
  selectRelatedContasReceberItemModel,
  selectRelatedReportModel,
  selectRelatedSelectionContasReceberList,
  selectRelatedSelectionContasReceberView,
} from '../../../../features/contas-receber/contasReceberSelectors';
import {
  changeToBatchApprovalMode,
  failure,
  loading,
  refresh as refreshAction,
  resetBackgroundMode,
  resetMode,
  resetModel,
  resetRefresh,
  resetRelatedSelectionContasReceberList,
  setRelatedContasReceberItemModel,
  setRelatedReportModel,
  setRelatedSelectionContasReceberView,
  success,
} from '../../../../features/contas-receber/contasReceberSlice';
import {
  fetchAllAsync,
  fetchAllViewAsync,
  generateReportAReceberByDateAsync,
} from '../../../../features/contas-receber/contasReceberThunks';
import { setErrorFeedback, setSuccessFeedback, setWarningFeedback } from '../../../../features/feedback/feedbackSlice';
import QCXJustifiedActionFormDialog from '../../../../shared-components/dialog/QCXJustifiedActionFormDialog';
import QCXListItemIcon from '../../../../shared-components/list-item-icon/QCXListItemIcon';
import TableCellWithTooltip from '../../../../shared-components/tooltip-cell/TableCellWithTooltip';
import QCXSimpleConsultPageTemplate from '../../../../templates/simple-consult-page/QCXSimpleConsultPageTemplate';
import contasReceberUtils from '../../../../utils/general/contas-receber/ContasReceberUtils';
import { convertLocalDateTimeStringToUTC } from '../../../../utils/general/dateTime-utils';
import {
  formatDate,
  normalizeData,
  normalizeNumeral,
  roundNumeral,
  unnormalizeNumeral,
} from '../../../../utils/general/general-utils';
import TituloUtils from '../../../../utils/general/titulo/TituloUtils';
import {
  CLOSED_STATUS,
  DONE_STATUS,
  FAIL_STATUS,
  SUBMITTING_STATUS,
} from '../../../../utils/hooks/form/dialog/formDialogUtils';
import useFormDialogAsync from '../../../../utils/hooks/form/dialog/useFormDialogAsync';
import useFormDialogSync from '../../../../utils/hooks/form/dialog/useFormDialogSync';
import { formatBrazilianNumericDecimal } from '../../../../utils/hooks/form/field/formatters';
import {
  isAlternativeLoadingStatus,
  isApprovalBatchMode,
  isNoneMode,
  isRefresh,
} from '../../../../utils/store/store-utils';
import SimpleConsultPageTemplate from '../../../../templates/simple-consult-page/SimpleConsultPageTemplate/SimpleConsultPageTemplate';
import ContasReceberFilterComponent from './components/ContasReceberFilterComponent';
import { selectUnidadeSelecionada } from '../../../../features/usuario-logado/usuarioLogadoSlice';
import { GiConsoleController } from 'react-icons/gi';
import QCXConfirmDialog from '../../../../shared-components/dialog/QCXConfirmDialog';
import useOperationMiddleware from '../../../../utils/hooks/operation/middleware/useOperationMiddleware';
import useGenericDownloader from '../../../../utils/hooks/downloader/useGenericDownloader';

export default function ContasReceberConsultPage({ authInfo = {} }) {
  const { t } = useTranslation();

  const { status } = useContext(ContasReceberContext);

  const mode = useSelector(selectMode);
  const dispatch = useDispatch();

  const refresh = useSelector(selectRefresh);
  const contasReceber = useSelector(selectContasReceberView);
  const relatedContasReceberItem = useSelector(selectRelatedContasReceberItemModel);
  const relatedSelectionContasReceberList = useSelector(selectRelatedSelectionContasReceberList);
  const relatedSelectionContasReceberView = useSelector(selectRelatedSelectionContasReceberView);
  const reportRelatedModel = useSelector(selectRelatedReportModel);

  const isNone = useMemo(() => isNoneMode(mode), [mode]);

  const isApprovalBatch = useMemo(() => isApprovalBatchMode(mode), [mode]);

  const isAlternativeLoading = useMemo(() => isAlternativeLoadingStatus(status), [status]);

  const [pageConfig, setPageConfig] = useState({
    currentPage: 0,
    pageSize: 10,
    filterInputValue: '',
  });

  const genericDownloader = useGenericDownloader({
    autoDownload: true,
  });

  const [fetchFilterParams, setFetchFilterParams] = useState([]);

  // const [isRecebido, setIsRecebido] = useState("NAO");

  const tenant = useSelector(selectUnidadeSelecionada);

  // const isAramTrust = tenant === 3869895 || tenant === 4957790;

  const resetModes = useCallback(() => {
    dispatch(resetMode());
    dispatch(resetBackgroundMode());
  }, []);

  const resetModels = useCallback(() => {
    dispatch(resetModel());
  }, []);

  const isEmptySelectionList = useMemo(
    () =>
      !relatedSelectionContasReceberView ||
      (_.isArrayLikeObject(relatedSelectionContasReceberView) && _.isEmpty(relatedSelectionContasReceberView)),
    [relatedSelectionContasReceberView]
  );

  const fetchAll = useCallback(() => {
    dispatch(fetchAllViewAsync(
      [
        {
          name: 'page',
          value: pageConfig.currentPage,
        },
        {
          name: 'size',
          value: pageConfig.pageSize,
        },
        {
          name: 'filter',
          value: pageConfig.filterInputValue,
        },
      ]
    ));
  }, [pageConfig]);

  useEffect(() => {
    resetModes();
    resetModels();
  }, []);

  useEffect(() => {
    fetchAll();
  }, [fetchAll])

  useEffect(() => {
    const checkIfIsRefresh = () => {
      if (isRefresh(refresh)) {
        fetchAll();
        dispatch(resetRefresh());
      }
    };

    checkIfIsRefresh();
  }, [refresh]);

  useEffect(() => {
    if (isNone && !isEmptySelectionList) {
      dispatch(resetRelatedSelectionContasReceberList());
    }
  }, [isNone, isEmptySelectionList]);

  useEffect(() => {
    console.log(tenant)
  }, [tenant]);

  const handleEnableBatchApprovalMode = useCallback((event) => {
    event.stopPropagation();
    dispatch(changeToBatchApprovalMode());
  }, []);

  const handleSelectionModelChange = useCallback(
    ({ selectionModel }) => {
      if (isApprovalBatch) {
        dispatch(setRelatedSelectionContasReceberView(selectionModel));
      }
    },
    [contasReceber, isApprovalBatch]
  );

  const [
    handleFormDialogConfirmBatchApprovalStatus,
    formDialogConfirmBatchApprovalStatus,
    setFormDialogConfirmBatchApprovalStatus,
  ] = useFormDialogSync();

  const handleCloseFormDialogNew = useCallback(() => {
    setFormDialogConfirmBatchApprovalStatus(CLOSED_STATUS);
  }, [setFormDialogConfirmBatchApprovalStatus]);

  const [openValorParcialDialog, valorParcialDialogStatus, setValorParcialDialogStatus] = useFormDialogAsync();

  const [openApplyJurosDialog, applyJurosDialogStatus, setApplyJurosDialogStatus] = useFormDialogAsync();

  const clientesSelecionados = useMemo(
    () =>
      new Set(
        relatedSelectionContasReceberView.map(
          (id) => contasReceber?.content?.find((c) => c.id === id)?.clienteId ?? null
        )
      ),
    [relatedSelectionContasReceberView, contasReceber]
  );

  const possuiClientesDiferentes = clientesSelecionados.size > 1;

  const avisarClientesDiferentes = () => {
    dispatch(
      setErrorFeedback({
        message: t('com.muralis.qcx.erro.baixaContasReceberClientesDiferentes'),
      })
    );
  };

  const handleOpenModal = () => {
    if (possuiClientesDiferentes) {
      avisarClientesDiferentes();
      return;
    }

    handleFormDialogConfirmBatchApprovalStatus('OPEN_STATUS');
  };

  const handleCancelBatchApproval = useCallback((event) => {
    event.stopPropagation();
    dispatch(resetMode());
  }, []);

  const [handleImprimirClick, formDialogImpressaoStatus, handleFormDialogImpressaoStatus] = useFormDialogSync(
    async (event, data) => {
      if (isFunction(event?.stopPropagation)) {
        event.stopPropagation();

        dispatch(
          setRelatedReportModel({
            ...data,
            tipo: contasReceberUtils.CONTAS_RECEBER,
          })
        );
      }
    },
    []
  );

  const handleImprimir = useCallback((row, popupState) => {

    const { id, status } = row;


    console.log(row);

  }, [])

  const isSingleItemSelected = useMemo(
    () => relatedSelectionContasReceberView.length === 1,
    [relatedSelectionContasReceberView]
  );

  const handleConfirmBatchApproval = useCallback(
    async (values) => {
      try {
        if (possuiClientesDiferentes) {
          handleCloseFormDialogNew();
          avisarClientesDiferentes();
          return;
        }

        dispatch(loading());

        handleCloseFormDialogNew();

        const contasReceberFiltrado = contasReceber?.content.map((conta) => ({
          id: conta?.id,
          contaBancaria: values?.contaBancariaId?.id || conta?.conta_bancaria_id,
          valor:
            isSingleItemSelected && values?.valorParcial && values?.valorParcial !== 0
              ? normalizeNumeral(values?.valorParcial)
              : saldoArredondado(conta), // Usa valorParcial apenas se for um item selecionado
          dataPagamento: values?.dataPagamento,
          solicitante: conta?.emailSolicitante,
          followUpId: conta?.followUpId,
          despesaReceitaId: conta?.despesaReceitaId,
          origem: conta?.origem,
          tipo: conta?.tipo,
          contaComissaria: conta?.controlarSaldo,
        }));

        const selectionModelContasReceberList = relatedSelectionContasReceberView.map((itemModel) => {
          const [contasReceberSelecionadas] = contasReceberFiltrado.filter((conta) => conta?.id === itemModel);
          return contasReceberSelecionadas;
        });

        const payload = selectionModelContasReceberList.map((contaReceber) => ({
          conta: {
            tipo: {
              description: contasReceberUtils.TITULO_TRANSFERENCIA,
            },
            proprietario: {
              id: contaReceber?.contaBancaria,
            },
          },
          referencias: [
            {
              id: contaReceber?.id,
            },
          ],
          operacao: {
            description: contasReceberUtils.TRANSFERENCIA,
          },
          valor: contaReceber?.valor,
          contaBancariaId: contaReceber?.contaBancaria,
          dataPagamento: contaReceber?.dataPagamento,
          solicitante: contaReceber?.solicitante,
          followUpId: contaReceber?.followUpId,
          despesaReceitaId: contaReceber?.despesaReceitaId,
          origem: contaReceber?.origem,
          tipo: contaReceber?.tipo,
          contaComissaria: contaReceber?.contaComissaria,
        }));

        let recebido = false;          // será decidido por conta
        if (isSingleItemSelected) {
          const conta = contasReceber?.content.find(
            (c) => c.id === relatedSelectionContasReceberView[0]
          );

          const saldoAnterior = calculoSaldo(conta);                // numérico
          const valorRecebido = normalizeNumeral(values?.valorParcial);
          const saldoRestante = saldoAnterior - valorRecebido;

          if (saldoRestante <= 0) {
            recebido = true;                    // quitou o título
          } else {
            // usuário decide se mantém aberto
            recebido = values?.manterSaldoAberto === "NAO";
          }
        }

        const query = [
          {
            name: 'recebido',
            value: recebido,
          },
        ]

        console.log(query);

        const response = await contasReceberAPI.transferencia(payload, query);

        if (response?.status === 201) {
          const feedbackMessage = t('com.muralis.qcx.mensagem.loteTransferenciaContasReceber');

          setValorParcialDialogStatus(CLOSED_STATUS);
          dispatch(success());
          dispatch(
            setSuccessFeedback({
              message: feedbackMessage,
            })
          );
          dispatch(refreshAction());
          dispatch(resetMode());
        }
      } catch (error) {
        console.log(error);
        const errorMessage = error?.message
          ? t('com.muralis.qcx.erro.transferirLoteContasReceberEspecifico', { erro: error?.response?.data })
          : t('com.muralis.qcx.erro.transferirContasReceberLote');
        dispatch(failure());
        dispatch(
          setErrorFeedback({
            message: errorMessage,
          })
        );
      }
    }, [contasReceber, relatedSelectionContasReceberView]);



  const handleImprimirByDateSubmit = async (event) => {
    event?.preventDefault?.();
    event?.stopPropagation?.();

    const vencimentoDe = normalizeData(event?.data?.vencimentoDe);
    const vencimentoAte = normalizeData(event?.data?.vencimentoAte);

    const handlers = {
      onNoContent: () => {
        dispatch(failure());

        const infoMessage = t('com.muralis.qcx.mensagem.nenhumRelatorioGerar');

        dispatch(
          setWarningFeedback({
            message: infoMessage,
          })
        );
      },
      onError: (message) => {
        dispatch(failure());

        const errorMessage =
          message ??
          t('com.muralis.qcx.mensagem.naoFoiPossivelGerarRelatorioContas', {
            tipoRelatorio: t('com.muralis.qcx.financeiro.contasReceber'),
          });

        dispatch(
          setErrorFeedback({
            message: errorMessage,
          })
        );
      },
    };

    dispatch(
      generateReportAReceberByDateAsync({
        vencimentoDe,
        vencimentoAte,
        handlers,
      })
    );

    handleFormDialogImpressaoStatus(DONE_STATUS);
  };

  const [handleOpenCancel, dialogCancelStatus, handleConsultCancelStatus] = useFormDialogSync(async (event, data) => {
    if (_.isFunction(event?.stopPropagation)) {
      event.stopPropagation();
      dispatch(setRelatedContasReceberItemModel(data));
    }
  }, []);

  const [cancelTituloFaturamento, setCancelTituloFaturamento] = useState(null);

  const handleCancelSubmit = useCallback(
    async ({ ...values }) => {
      if (values?.origem === 'FATURAMENTO' && !values?.reabrirFaturamentoConfirmado) {
        setCancelTituloFaturamento(values);
        return;
      }

      try {
        dispatch(loading());
        handleConsultCancelStatus(SUBMITTING_STATUS);

        const response = await contasReceberAPI.cancelar({
          id: values?.id,
          justificativa: values?.justificativa,
        });

        if (response?.status === 200) {
          const feedbackMessage = t('com.muralis.qcx.mensagem.contaReceberCancelada');

          handleConsultCancelStatus(DONE_STATUS);
          dispatch(success());
          dispatch(
            setSuccessFeedback({
              message: feedbackMessage,
            })
          );
          dispatch(refreshAction());
        }
      } catch (error) {
        const errorMessage = error?.message
          ? t('com.muralis.qcx.erro.cancelarContasReceberEspecifico', { erro: error?.response?.data?.message })
          : t('com.muralis.qcx.erro.cancelarContasReceber');
        dispatch(
          setErrorFeedback({
            message: errorMessage,
          })
        );
        dispatch(failure());
        handleConsultCancelStatus(FAIL_STATUS);
      }
    },
    [handleConsultCancelStatus]
  );

  function calculateDesconto({ row }) {
    const desconto = (row?.desconto ?? 0) / 100;
    const valorDescontado = row?.valor + row?.valor * desconto;

    const valorFormatado = unnormalizeNumeral(valorDescontado, formatBrazilianNumericDecimal(2)) || 0;

    return valorFormatado;
  }

  function calculateDescontoView({ row }) {

    const desconto = (row?.desconto ?? 0) / 100;

    const valorDescontado = row?.valorReceber + row?.valorReceber * desconto;

    const valorFormatado = unnormalizeNumeral(valorDescontado, formatBrazilianNumericDecimal(2)) || 0;

    return valorFormatado;
  }

  function calculoValorRecebido({ row }) {

    let valorRecebido = 0;

    if (row.valorMovimentacoesEntrada > row.valorMovimentacoesSaida) {
      valorRecebido = (row.valorMovimentacoesEntrada - row.valorMovimentacoesSaida);
    } else {
      valorRecebido = (row.valorMovimentacoesSaida - row.valorMovimentacoesEntrada);
    }

    const valorFormatado = unnormalizeNumeral(valorRecebido, formatBrazilianNumericDecimal(2)) || 0;

    return valorFormatado;

  }

  function calculoValorRecebidoNumber(row) {

    let valorRecebido = 0;

    if (row.valorMovimentacoesEntrada > row.valorMovimentacoesSaida) {
      valorRecebido = (row.valorMovimentacoesEntrada - row.valorMovimentacoesSaida);
    } else {
      valorRecebido = (row.valorMovimentacoesSaida - row.valorMovimentacoesEntrada);
    }

    return valorRecebido;

  }

  function calculoSaldoContasReceber({ row }) {

    if (contasReceberUtils.isRecebido(row?.status)) {
      return unnormalizeNumeral(0, formatBrazilianNumericDecimal(2));
    }

    const desconto = ((row?.desconto ?? 0) / 100);
    const valorDescontado = row?.valorReceber + (row?.valorReceber * desconto);

    const valorRecebido = calculoValorRecebidoNumber(row);

    const valorSaldo = valorDescontado - valorRecebido;

    const valorFormatado = unnormalizeNumeral(valorSaldo, formatBrazilianNumericDecimal(2)) || 0;

    return valorFormatado;
  };

  function calculoSaldo(row) {

    if (!row) {
      return 0;
    }

    const desconto = ((row?.desconto ?? 0) / 100);

    const valorDescontado = row?.valorReceber + (row?.valorReceber * desconto);

    const valorRecebido = calculoValorRecebidoNumber(row);

    const valorSaldo = valorDescontado - valorRecebido;

    return valorSaldo;

  }

  function saldoArredondado(row) {
    return Math.round(calculoSaldo(row) * 100) / 100;
  }

  const [rowToApplyJuros, setRowToApplyJuros] = useState();

  function handleOpenApplyJuros(event, row) {
    setRowToApplyJuros(row);
    openApplyJurosDialog();
  }

  async function handleApplyJuros(values) {

    try {

      dispatch(loading());

      const response = await contasReceberAPI.atualizarJurosView(
        rowToApplyJuros?.id, {
        tipo: values?.tipo,
        formato: values?.formato,
        desconto: normalizeNumeral(values?.desconto),
      });

      if (response?.status === 200) {
        const feedbackMessage = 'Juros Atualizados com sucesso';

        setApplyJurosDialogStatus(CLOSED_STATUS);
        dispatch(success());
        dispatch(
          setSuccessFeedback({
            message: feedbackMessage,
          })
        );
        dispatch(refreshAction());
      }
    } catch (error) {
      const errorMessage = 'Falha ao atualizar os juros!';
      dispatch(
        setErrorFeedback({
          message: errorMessage,
        })
      );
      dispatch(failure());
      setApplyJurosDialogStatus(FAIL_STATUS);
    }
  }


  const [valorParcial, setValorParcial] = useState(0);

  useEffect(() => {
    const calculatedValue = relatedSelectionContasReceberView.reduce((acc, id) => {
      const conta = contasReceber?.content.find((c) => c.id === id);
      return acc + saldoArredondado(conta);
    }, 0);

    setValorParcial(calculatedValue);
  }, [relatedSelectionContasReceberView, contasReceber]);

  const [handleImprimirReciboMiddleware, operationImprimirRecibo] = useOperationMiddleware(async (data) => {

    const fetcher = async () => {

      dispatch(loading());

      const filterParams = [
        {
          name: 'titulo_id',
          value: data?.id,
        },
      ];

      const response = await contasReceberAPI.fetchRelatorioModeloCredito(filterParams);

      return response;
    };

    const handlers = {
      onSuccess: () => {
        dispatch(success());

        const successMessage = "Recibo emitido com sucesso !";

        dispatch(
          setSuccessFeedback({
            message: successMessage,
          })
        );

        dispatch(refreshAction());

      },
      onNoContent: () => {

        dispatch(failure());

        const infoMessage = 'Não foi possivel gerar o recibo.';

        dispatch(
          setErrorFeedback({
            message: infoMessage,
          })
        );
      },
      onError: (reason) => {
        dispatch(failure());

        const errorMessage = 'Error ao tentar gerar o recibo.'

        dispatch(
          setErrorFeedback({
            message: errorMessage,
          })
        );
      },
    };

    genericDownloader.downloadFileById(fetcher, handlers);
  }, []);

  const handleImprimirRecibo = useCallback((row, popupState) => {
    const { id } = row;

    const handleGeneratePrestacaoClick = (event) => {

      if (isFunction(event?.stopPropagation)) {

        popupState.close(event);

        event.stopPropagation();

        const configureOperation = () => ({
          options: {
            title: 'Deseja emitir o recibo ?',
            message: t('com.muralis.qcx.mensagem.confirmarOperacaoEmitirPrestacaoContas'),
          },
        });

        const data = { id };

        handleImprimirReciboMiddleware(configureOperation, data);

      }
    }

    return handleGeneratePrestacaoClick;

  }, [handleImprimirReciboMiddleware])

  const [handleFinalizarSaldoMiddleware, operationFinalizarSaldo] = useOperationMiddleware(async (data) => {
    try {

      dispatch(loading());

      const response = await contasReceberAPI.finalizarSaldo(data?.id);

      if (response?.status === 200) {
        dispatch(success());
        dispatch(
          setSuccessFeedback({
            message: t('com.muralis.qcx.mensagem.finalizarSaldoContasReceber'),
          })
        );
        dispatch(refreshAction());
        dispatch(resetMode());
      }
    } catch (error) {
      dispatch(failure());
      dispatch(
        setErrorFeedback({
          message: error?.response?.data
            ? t('com.muralis.qcx.erro.finalizarSaldoContasReceberEspecifico', { erro: error?.response?.data })
            : t('com.muralis.qcx.erro.finalizarSaldoContasReceber'),
        })
      );
    }
  }, []);

  const handleFinalizarSaldo = useCallback((row, popupState) => (event) => {

    if (isFunction(event?.stopPropagation)) {
      popupState.close(event);
      event.stopPropagation();
    }

    const configureOperation = () => ({
      options: {
        title: t('com.muralis.qcx.acoes.finalizarSaldoTitulo'),
        message: t('com.muralis.qcx.mensagem.confirmarOperacaoFinalizarSaldo'),
      },
    });

    const data = {
      id: row?.id,
    };

    handleFinalizarSaldoMiddleware(configureOperation, data);

  }, [handleFinalizarSaldoMiddleware]);


  const columns = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        headerAlign: 'center',
        align: 'center',
        type: 'string',
        flex: 120,
        valueGetter: ({ row }) => row?.origemId || '-',
        renderCell: ({ row }) => <TableCellWithTooltip value={row?.origemId || '-'} />,
      },
      {
        field: 'processo',
        headerName: t('com.muralis.qcx.NumeroProcesso'),
        headerAlign: 'center',
        align: 'center',
        type: 'string',
        flex: 150,
        valueGetter: ({ row }) => row?.numeroProcesso || '-',
        renderCell: ({ row }) => <TableCellWithTooltip value={row?.numeroProcesso || '-'} />,
      },
      {
        field: 'origem',
        headerName: t('com.muralis.qcx.origem'),
        headerAlign: 'center',
        align: 'center',
        type: 'string',
        flex: 180,
        valueGetter: ({ row }) => row?.origem || '-',
      },
      {
        field: 'solicitacao',
        headerName: t('com.muralis.qcx.solicitacao'),
        headerAlign: 'center',
        align: 'center',
        type: 'date',
        flex: 150,
        valueGetter: ({ row }) => formatDate(row?.solicitacao) || '-',
      },
      {
        field: 'cliente',
        headerName: t('com.muralis.qcx.cliente.label'),
        headerAlign: 'center',
        align: 'center',
        type: 'string',
        flex: 120,
        valueGetter: ({ row }) => row?.cliente || '-',
        renderCell: ({ row }) => <TableCellWithTooltip value={row?.cliente || '-'} />,
      },
      {
        field: 'valorReceber',
        headerName: t('com.muralis.qcx.valorReceber'),
        headerAlign: 'center',
        align: 'center',
        type: 'number',
        flex: 150,
        valueGetter: ({ row }) => row?.valorReceber,
        valueFormatter: ({ row }) => unnormalizeNumeral(row?.valorReceber, formatBrazilianNumericDecimal(2)) || '-',
      },
      {
        field: 'desconto',
        headerName: 'Desconto / Juros',
        headerAlign: 'center',
        align: 'center',
        type: 'number',
        flex: 150,
        valueGetter: ({ row }) => row?.desconto,
        valueFormatter: ({ row }) => unnormalizeNumeral(row?.desconto, formatBrazilianNumericDecimal(2, true)) || 0,
      },
      {
        field: 'valorDescontado',
        headerName: 'Valor Real',
        headerAlign: 'center',
        align: 'center',
        type: 'number',
        flex: 150,
        valueGetter: calculateDescontoView,
      },
      {
        field: 'valorRecebido',
        headerName: t('com.muralis.qcx.valorRecebido'),
        headerAlign: 'center',
        align: 'center',
        type: 'number',
        flex: 150,
        valueGetter: calculoValorRecebido,
      },
      {
        field: 'saldo',
        headerName: t('com.muralis.qcx.saldo'),
        headerAlign: 'center',
        align: 'center',
        type: 'numeric',
        flex: 150,
        valueGetter: calculoSaldoContasReceber,
      },
      {
        field: 'dataPagamento',
        headerName: 'Data Pagamento',
        headerAlign: 'center',
        align: 'center',
        type: 'string',
        flex: 150,
        valueGetter: ({ row }) =>
          row?.dataPagamento ? formatDate(convertLocalDateTimeStringToUTC(row?.dataPagamento)) : '-',
      },
      {
        field: 'status',
        headerName: t('com.muralis.qcx.status'),
        headerAlign: 'center',
        align: 'center',
        type: 'string',
        flex: 150,
        valueGetter: ({ row }) => row?.status || '-',
      },
      {
        field: 'dataVencimento',
        headerName: t('com.muralis.qcx.dataVencimento'),
        headerAlign: 'center',
        align: 'center',
        type: 'string',
        flex: 150,
        valueGetter: ({ row }) => row?.vencimento || '-',
      },
      {
        field: 'actions',
        headerName: t('com.muralis.qcx.acoes.label'),
        headerAlign: 'center',
        align: 'center',
        flex: 180,
        renderCell: ({ row }) => (
          <>
            <QCXPopupState popupId="popup-menu-contas-receber">
              {(popupState) => (
                <>
                  <IconButton
                    key={`btn-more-options-${row?.id}`}
                    name={`btn-more-options-${row?.id}`}
                    {...bindTrigger(popupState)}
                    disabled={isApprovalBatch || TituloUtils.isOrigemConciliacao(row?.origem)}
                  >
                    <MoreHorizIcon
                      color={isApprovalBatch || TituloUtils.isOrigemConciliacao(row?.origem) ? 'disabled' : 'secondary'}
                      size={20}
                    />
                  </IconButton>
                  <Menu {...bindMenu(popupState)}>
                    <MenuItem
                      onClick={(event) => {
                        handleOpenCancel(event, row);
                      }}
                      disabled={
                        contasReceberUtils.isRecebido(row?.status) ||
                        contasReceberUtils.isCancelado(row?.status) ||
                        TituloUtils.isOrigemTransferencia(row?.origem)
                      }
                    >
                      <QCXListItemIcon>
                        <CancelIcon fontSize="small" color="error" />
                      </QCXListItemIcon>
                      <Typography
                        variant="inherit"
                        style={{
                          fontSize: 12,
                        }}
                      >
                        {t('com.muralis.qcx.acoes.cancelar').toUpperCase()}
                      </Typography>
                    </MenuItem>
                    <MenuItem
                      onClick={(event) => {
                        handleOpenApplyJuros(event, row);
                      }}
                    >
                      <QCXListItemIcon>
                        <PaymentIcon fontSize="small" />
                      </QCXListItemIcon>
                      <Typography
                        variant="inherit"
                        style={{
                          fontSize: 12,
                        }}
                      >
                        {'Aplicar Juros/Desconto'.toUpperCase()}
                      </Typography>
                    </MenuItem>
                    <MenuItem
                      onClick={handleFinalizarSaldo(row, popupState)}
                      disabled={!contasReceberUtils.isRecebidoParcialmente(row?.status)}
                    >
                      <QCXListItemIcon>
                        <DoneAllIcon fontSize="small" htmlColor="green" />
                      </QCXListItemIcon>
                      <Typography
                        variant="inherit"
                        style={{
                          fontSize: 12,
                        }}
                      >
                        {t('com.muralis.qcx.acoes.finalizarSaldo').toUpperCase()}
                      </Typography>
                    </MenuItem>
                    {
                      <MenuItem
                        onClick={handleImprimirRecibo(row, popupState)}
                        disabled={
                          !contasReceberUtils.isRecebido(row?.status) ||
                          contasReceberUtils.isCancelado(row?.status)
                        }
                      >
                        <QCXListItemIcon>
                          <SummarizeIcon htmlColor="orange" size="small" />
                        </QCXListItemIcon>
                        <Typography variant="inherit" style={{ fontSize: 12, }}>
                          IMPRIMIR RECIBO
                        </Typography>
                      </MenuItem>
                    }
                  </Menu>
                </>
              )}
            </QCXPopupState>
          </>
        ),
      },
    ],
    [isApprovalBatch, handleOpenCancel, handleFinalizarSaldo]
  );

  const breadcrumbs = useMemo(
    () => [
      {
        link: {
          to: '/',
          name: t('com.muralis.qcx.inicio'),
        },
      },
      {
        link: {
          to: t('com.muralis.qcx.url.moduloFinanceiro'),
          name: t('com.muralis.qcx.financeiro.label'),
        },
      },
      {
        text: {
          name: t('com.muralis.qcx.financeiro.contasReceber'),
        },
        default: true,
      },
    ],
    []
  );

  function isFullPayed(valor, movimentacoes) {
    const valorRecebido = contasReceberUtils.calculoValorRecebido(movimentacoes);

    return valorRecebido >= valor;
  }

  function possuiSaldo(row) {

    const saldo = calculoSaldo(row);
    return saldo <= 0;

  }

  const handleConfigChange = useCallback(({ currentPage, pageSize, filterInputValue, advancedFilter }) => {


    const {
      data_solicitacao_pagamento: dataSolicitacaoPagamento,
      cliente,
      valor_receber: valorReceber,
      desconto,
      data_vencimento: dataVencimento,
      status,
    } = advancedFilter;

    const filter = filterInputValue;

    const pageParams = [
      { name: 'page', value: currentPage },
      { name: 'size', value: pageSize },
    ];

    const filterParams = [
      { name: 'filter', value: filterInputValue },
      { name: 'data_solicitacao_pagamento', value: dataSolicitacaoPagamento },
      { name: 'cliente', value: cliente },
      { name: 'valor_receber', value: valorReceber },
      { name: 'desconto', value: desconto },
      { name: 'data_vencimento', value: dataVencimento },
      { name: 'status', value: status },
    ];

    const params = pageParams.concat(filterParams);

    setFetchFilterParams(filterParams);

    dispatch(fetchAllViewAsync(params));

  }, []);

  const selectedRow = isSingleItemSelected
    ? contasReceber?.content.find(
      (c) => c.id === relatedSelectionContasReceberView[0],
    )
    : null;

  const templateProps = useMemo(
    () => ({
      page: {
        title: t('com.muralis.qcx.financeiro.contasReceber'),
        icon: <ReceiptIcon />,
        breadcrumbs,
      },
      control: {
        others: [
          ...(isNone
            ? [
              {
                description: t('com.muralis.qcx.relatorios.label'),
                disabled: false,
                color: 'primary',
                onClick: handleImprimirClick,
              },
              {
                description: <CheckCircleIcon size={20} color="white" />,
                ...(_.isEmpty(contasReceber || [])
                  ? {
                    disabled: true,
                    color: 'disabled',
                  }
                  : {
                    disabled: false,
                    style: {
                      backgroundColor: 'green',
                    },
                  }),
                onClick: handleEnableBatchApprovalMode,
              },
            ]
            : []),
          ...(isApprovalBatch
            ? [
              {
                description: t('com.muralis.qcx.acoes.confirmarSelecao'),
                startIcon: <CheckCircleIcon />,
                color: 'secondary',
                tooltip: {
                  description: t('com.muralis.qcx.acoes.confirmarSelecao'),
                },
                onClick: handleOpenModal,
                disabled: isEmptySelectionList,
              },
              {
                description: <CancelOutlinedIcon />,
                variant: 'outlined',
                color: 'default',
                tooltip: {
                  description: t('com.muralis.qcx.acoes.cancelar'),
                },
                onClick: handleCancelBatchApproval,
              },
            ]
            : []),
        ],
      },
      table: {
        columns,
        onConfigChangeCallback: handleConfigChange,
        rowsPerPageOptions: [5, 10, 25, 50, 100],
        rowsCount: contasReceber.totalElements,
        checkboxSelection: isApprovalBatch,
        selectionModel: relatedSelectionContasReceberView,
        onSelectionModelChange: handleSelectionModelChange,
        isRowSelectable: (table) =>
        (
          (
            table?.row?.status === contasReceberUtils.PENDENTE ||
            table?.row?.status === contasReceberUtils.RECEBIDO_PARCIALMENTE
          ) &&
          !possuiSaldo(table?.row) &&
          !TituloUtils.isOrigemConciliacao(table?.row?.origem)
        ),
      },
    }),
    [
      breadcrumbs,
      columns,
      isApprovalBatch,
      isEmptySelectionList,
      contasReceber,
      handleCancelBatchApproval,
      handleConfirmBatchApproval,
      handleSelectionModelChange,
      handleEnableBatchApprovalMode,
      relatedSelectionContasReceberView,
      handleConfigChange,
    ]
  );


  return (
    <SimpleConsultPageTemplate
      pageProps={templateProps.page}
      controlProps={templateProps.control}
      tableProps={templateProps.table}
      tableData={contasReceber.content}
      isLoading={isAlternativeLoading}
      authInfo={authInfo}
      requiredRoles={['conta-receber']}
      advancedFilterFormChildren={ContasReceberFilterComponent}
      advancedFilterKeyAccessors={['data_solicitacao_pagamento', 'cliente', 'valor_receber', 'desconto', 'data_vencimento', 'status']}
      clearSelection
    >
      <QCXConfirmDialog
        key="confirm-dialog-cancelar-titulo-faturamento"
        id="confirm-dialog-cancelar-titulo-faturamento"
        open={!!cancelTituloFaturamento}
        title={t('com.muralis.qcx.acoes.confirmarOperacao')}
        content={t('com.muralis.qcx.mensagem.confirmarCancelarTituloFaturamento')}
        onConfirm={() => {
          const values = cancelTituloFaturamento;
          setCancelTituloFaturamento(null);
          handleCancelSubmit({ ...values, reabrirFaturamentoConfirmado: true });
        }}
        onClose={() => setCancelTituloFaturamento(null)}
      />
      <QCXConfirmDialog
        key="confirm-dialog-gerar-nota-despesas"
        id="confirm-dialog-gerar-nota-despesas"
        open={operationImprimirRecibo?.active}
        title={operationImprimirRecibo?.title}
        content={operationImprimirRecibo?.message}
        endContent={operationImprimirRecibo?.endMessage}
        onConfirm={operationImprimirRecibo.confirm}
        onClose={operationImprimirRecibo?.reset}
      />
      <QCXConfirmDialog
        key="confirm-dialog-finalizar-saldo"
        id="confirm-dialog-finalizar-saldo"
        open={operationFinalizarSaldo?.active}
        title={operationFinalizarSaldo?.title}
        content={operationFinalizarSaldo?.message}
        endContent={operationFinalizarSaldo?.endMessage}
        onConfirm={operationFinalizarSaldo.confirm}
        onClose={operationFinalizarSaldo?.reset}
      />
      <QCXJustifiedActionFormDialog
        handleSubmit={handleCancelSubmit}
        status={dialogCancelStatus}
        handleStatus={handleConsultCancelStatus}
        type={contasReceberUtils.CANCELAR}
        initialValues={relatedContasReceberItem}
      />
      <QCXRelatoriosContasDialogForm
        handleFormStatus={handleFormDialogImpressaoStatus}
        handleOnSubmit={(event) => handleImprimirByDateSubmit(event)}
        formDialogStatus={formDialogImpressaoStatus}
        initialValues={reportRelatedModel}
        typeReport={contasReceberUtils.CONTAS_RECEBER}
      />
      <QCXPartialValuesDialogForm
        handleFormStatus={setFormDialogConfirmBatchApprovalStatus}
        handleOnSubmit={(formData) => handleConfirmBatchApproval(formData)}
        formDialogStatus={formDialogConfirmBatchApprovalStatus}
        initialValues={{
          ...reportRelatedModel,
          valorParcial: isSingleItemSelected
            ? roundNumeral(calculoSaldo(
              contasReceber?.content.find(
                (c) => c.id === relatedSelectionContasReceberView[0]
              )
            ))
            : roundNumeral(valorParcial),
          origem: selectedRow?.origem ?? '',
          valorSaldoInicial: roundNumeral(valorParcial),
          valorAtual: isSingleItemSelected
            ? roundNumeral(calculoSaldo(
              contasReceber?.content.find(
                (c) => c.id === relatedSelectionContasReceberView[0]
              )
            ))
            : roundNumeral(valorParcial),
        }}
        isSingleItemSelected={isSingleItemSelected}
      />
      <QCXApplyJurosDialogForm
        handleFormStatus={setApplyJurosDialogStatus}
        handleOnSubmit={(values) => handleApplyJuros(values)}
        formDialogStatus={applyJurosDialogStatus}
      />
    </SimpleConsultPageTemplate>
  );
}
